export const OKP_PARTNER_NAME = "OKP application";
export const GRUENDUNGSPLATTFORM_PARTNER_NAME = "Gründungsplattform";
export const UWD_PARTNER_NAME = "Unternehmenswerkstatt";
// Altbestand: vor der Umbenennung hieß die Unternehmenswerkstatt-PartnerApplication
// im BE "Gründungswerkstatt". Bestandsanfragen können diesen Namen noch tragen.
export const GWD_PARTNER_NAME = "Gründungswerkstatt";

// Labels analog zum BE-Reporting (config/locales/de.yml -> sources).
const SOURCE_LABELS = {
  [OKP_PARTNER_NAME]: "OKP-Strecke",
  [GRUENDUNGSPLATTFORM_PARTNER_NAME]: "Gründungsplattform",
  [UWD_PARTNER_NAME]: "Unternehmenswerkstatt",
  [GWD_PARTNER_NAME]: "Unternehmenswerkstatt"
};

// Übersetzt den partner_name aus dem BE in das anzuzeigende Quellen-Label.
export const getPartnerSourceLabel = partnerName =>
  (partnerName && SOURCE_LABELS[partnerName]) || partnerName;

export default {
  OKP_PARTNER_NAME,
  GRUENDUNGSPLATTFORM_PARTNER_NAME,
  UWD_PARTNER_NAME,
  GWD_PARTNER_NAME,
  getPartnerSourceLabel
};
